<template>
  <container>
    <h1 style="font-size:25px;">Active Runs</h1>

<div style="margin-bottom:50px">
<div style= "width: 65%;text-align: right;" class="refresh-data">
    <h1 style="font-size: 20px;float: left;text-align: right;line-height: 1;padding: 7px 0px;">ST6</h1>
    <button id="refresh-btn" class="btn btn--primary" @click="initializeSt6()">Refresh St6 Data</button>
</div>

<div class="active-run-table">
   <v-table
    :is-loading="loading.st6"
    :width="850"
    :columns="columns"
    :table-data="tableDataSt6"
    :show-vertical-border="true"
    :title-bg-color = "'#969696'"
    :title-color = "'#fff'"
    :title-row-height ="30"
    :border="1"
    @on-custom-comp="customFuncSt6"
   
  ></v-table>
  </div>
  </div>



<div style="margin-bottom:50px">
  <div style= "width: 65%;text-align: right;" class="refresh-data">
    <h1 style="font-size: 20px;float: left;text-align: right;line-height: 1;padding: 7px 0px;">ST5</h1>
   <button id="refresh-btn" class="btn btn--primary" @click="initializeSt5()">Refresh St5 Data</button>
   </div>

  <div class="active-run-table">
   <v-table
    :is-loading="loading.st5"
    :width="850"
    :columns="columns"
    :table-data="tableDataSt5"
    :show-vertical-border="true"
    :title-bg-color = "'#969696'"
    :title-color = "'#fff'"
    :title-row-height ="30"
    :border="1"
    @on-custom-comp="customFuncSt5">
  </v-table>
  </div>
</div>

<div style="margin-bottom:50px">
  <div style= "width: 65%;text-align: right;" class="refresh-data">
    <h1 style="font-size: 20px;float: left;text-align: right;line-height: 1;padding: 7px 0px;">ST4</h1>
   <button id="refresh-btn" class="btn btn--primary" @click="initializeSt4()">Refresh St4 Data</button>
   </div>

  <div class="active-run-table">
   <v-table
    :is-loading="loading.st4"
    :width="850"
    :columns="columns"
    :table-data="tableDataSt4"
    :show-vertical-border="true"
    :title-bg-color = "'#969696'"
    :title-color = "'#fff'"
    :title-row-height ="30"
    :border="1"
    @on-custom-comp="customFuncSt4">
  </v-table>
  </div>
</div>
   
  </container>
</template>
<script>
import Container from "@/components/Container"
import { mapActions, mapGetters } from "vuex"
import RaceResumeService from '@/services/raceResume'
import TextField from '@/components/Forms/TextField'
import {VTable,VPagination} from 'vue-easytable'
import Vue from 'vue'
import axios from 'axios'
import { db } from '../../../firebase'
let dialogOptions = {
    html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
    loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
    reverse: false, // switch the button positions (left to right, and vise versa)
    cancelText: 'No',
    okText: 'Yes',
    animation: 'zoom', // Available: "zoom", "bounce", "fade"
    type: 'basic', // coming soon: 'soft', 'hard'
    verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
    clicksCount: 3,
    animation: 'bounce', // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
  }
export default {
  name: "active-run",
  data() {
    return {
      activeRun:{},
      apiName:'st6',
      apiUrl: '', // Will be set in created() from this.$expressApi
      tableData: [],
      tableDataLocal: [],
      tableDataSt6: [],
      tableDataSt5: [],
      tableDataSt4: [],     
      columns: [ 
          {field: "raceId", title:'Race Id', width: 100, titleAlign: 'center',columnAlign:'center'},
          {field: "raceStatus", title:'Race Status', width: 100, titleAlign: 'center',columnAlign:'center'},
          {field:"mode", title:'Mode', width: 80, titleAlign: 'center',columnAlign:'center'},
          {
            field: 'custome', title:'Creator Id', width: 180, titleAlign: 'center', columnAlign: 'center',
            formatter: function (rowData,rowIndex,pagingIndex,field) {
               if(rowData.raceDetail!=undefined && rowData.raceDetail.trainer!=undefined){
                  return '<span>' + rowData.raceDetail.trainer.id + '</span>' 
               }else{
                  return '<span> - </span>'
               }
            },
          },
          {
            field: 'custome', title:'Creator Name', width: 200, titleAlign: 'center', columnAlign: 'center',
            formatter: function (rowData,rowIndex,pagingIndex,field) {
              if(rowData.raceDetail!= undefined && rowData.raceDetail.trainer!=undefined){
                return '<span>' + rowData.raceDetail.trainer.firstName +' '+ rowData.raceDetail.trainer.lastName + '</span>' 
              }else{
                return '<span> - </span>'
              }
            },
          },
           {field: 'custome-adv', title: 'Operation', titleAlign: 'center',columnAlign:'center',
          componentName:'table-operation',isResize:true},
           
      ],
      isLoading: true,
      loading:{
        st6:false,
        st5:false,
        st4:false,
        local:false
      },      
      expressApi:'',
      raceFirebase: {},
    }
  },
  computed: {
    // alert () {
    //   return this.$store.getters['Alert/alert']
    // }
  },
  methods: {
    // ...mapActions({
    //   setAlert: "Alert/setAlert"
    // }),
     initializeSt6() {
      this.loading.st6 = true
      // axios.get(this.$expressApi+`active-run`).then(
      // axios.get("http://localhost:3005/active-run", { headers: { Authorization: AuthStr } })
      const AuthStr = 'Bearer '.concat(window.localStorage.getItem('default-auth-token'))
      axios.get(`${this.$expressApi}active-run`, { headers: { Authorization: AuthStr } })
      .then(response => {
          console.log("res st6 ---", response.data)
          response.data.forEach(function (n) {
            if(n.raceId == undefined){
              n.raceId = n.id
            }
          })
          this.tableDataSt6 = response.data
          this.loading.st6 = false
        },
        error => {
          //this.tableDataSt6 = null
          this.isLoading = false
          this.loading.st6 = false
          console.log("error---", error)
        }
      )
    },
     initializeLocal() {
      this.loading.local = true
      const AuthStr = 'Bearer '.concat(window.localStorage.getItem('default-auth-token'))
      axios.get(`http://localhost:3007/active-run`, { headers: { Authorization: AuthStr } })
      .then(response => {
          console.log("resp local---", response.data)
          response.data.forEach(function (n) {
            if(n.raceId == undefined){
              n.raceId = n.id
            }
          })
          this.loading.local = false
          this.tableDataLocal = response.data
        },
        error => {
          this.tableDataLocal = null
          this.loading.local = false
          console.log("error---", error)
        }
      )
    },
    initializeSt5() {
      this.loading.st5 = true
      const AuthStr = 'Bearer '.concat(window.localStorage.getItem('default-auth-token'))
      axios.get(`${this.$expressApi}active-run`, { headers: { Authorization: AuthStr } })
      .then(response => {
          console.log("resp tableDataSt5---", response.data)  
          response.data.forEach(function (n) {
            if(n.raceId == undefined){
              n.raceId = n.id
            }
          })        
          this.tableDataSt5 = response.data
          this.loading.st5 = false
        },
        error => {
          this.tableDataSt5 = null
          this.loading.st5 = false
          console.log("error---", error)
        }
      )
    },
    initializeSt4() {
      this.loading.st4 = true
      const AuthStr = 'Bearer '.concat(window.localStorage.getItem('default-auth-token'))
      axios.get(`${this.$expressApi}active-run`, { headers: { Authorization: AuthStr } })
      .then(response => {
          console.log("resp st4---", response.data)
          response.data.forEach(function (n) {
            if(n.raceId == undefined){
              n.raceId = n.id
            }
          })
          this.loading.st4 = false
          this.tableDataSt4 = response.data
        },
        error => {
          this.tableDataSt4 = null
          this.loading.st4 = false
          console.log("error---", error)
        }
      )
    },

    
    initialize() {
      this.isLoading = true
      // axios.get(this.$expressApi+`active-run`).then(
      // axios.get("http://localhost:3005/active-run", { headers: { Authorization: AuthStr } })
      const AuthStr = 'Bearer '.concat(window.localStorage.getItem('default-auth-token'))
      axios.get(this.$expressApi+`active-run`, { headers: { Authorization: AuthStr } })
      .then(response => {
          console.log("resp---", response.data)
          console.log("resp length---", response.data.length)
          this.isLoading = false
          this.tableData = response.data
          this.activeRun = response.data
        },
        error => {
          this.tableData = null
          this.isLoading = false
          console.log("error---", error)
        }
      )
    },
     // customCompFunc(params) {
    //   console.log("params--", params)
    //   var raceId = params.rowData.raceId
    //   // console.log("raceId-->", raceId)
      
    //   if(raceId !=undefined){
    //     this.$dialog
    //       .confirm("レースを終了しますか？", dialogOptions)
    //       .then(async dialog => {
    //       this.isLoading = true
    //       console.log("inside dialog>>", `/${this.$fbDbEntry}/${raceId}`)
    //       if(params.rowData.raceStatus == "running"){
    //         console.log("running mode----")
    //         this.endRace(raceId)
    //       }else{
    //         console.log("finished mode----")
    //         //this.$delete(this.tableData,params.index)        
    //         this.finishRace(raceId)            
    //       }         
    //     })
    //   }
    // },
    customFuncSt6(params){
      this.apiUrl = this.$expressApi // Use environment config from main.js
      this.apiName="st6"
      this.checkRaceStatus(params)
    },
    customFuncLocal(params){
      this.apiUrl = 'http://localhost:3007/'
      this.apiName="local"
      this.checkRaceStatus(params)
    },
    customFuncSt5(params){
      this.apiUrl = this.$expressApi // Use environment config from main.js
      this.apiName="st5"
      this.checkRaceStatus(params)
    },
    customFuncSt4(params){
      this.apiUrl = this.$expressApi // Use environment config from main.js
      this.apiName="st4"
      this.checkRaceStatus(params)
    },

    checkRaceStatus(params) {
      console.log("params--", params)
      var raceId = params.rowData.raceId
      // console.log("raceId-->", raceId)
      var fbEntry = params.rowData.fbDbEntry
      
      if(raceId !=undefined){
        this.$dialog
          .confirm("レースを終了しますか "+raceId+"?", dialogOptions)
          .then(async dialog => {
          this.loading[this.apiName] = true
          //console.log("inside dialog>>", `/${this.$fbDbEntry}/${raceId}`)
          if(params.rowData.raceStatus == "running"){
            console.log("running mode----")
            this.endRace(raceId,fbEntry)
          }else{
            console.log("finished mode----")
            //this.$delete(this.tableData,params.index)        
            this.finishRace(raceId,fbEntry)            
          }         
        })
      }
    },

   
    async endRace(raceId,fbEntry){
            console.log("1endrace-fbEntry-",fbEntry)
            _LTracker.push('Race::: '+ raceId +' Finished By Trainer: ' + this.$auth.user().id)
            db.ref(`/${fbEntry}/${raceId}`).update({
                  'status': 'finished'
            })            
           // this.$bindAsObject('raceFirebase', db.ref(`/${this.$fbDbEntry}/${raceId}`))

            await db.ref(`/${fbEntry}/${raceId}`).once('value', (raceFirebase) => {
                console.log("runnerFirebase---",raceFirebase.val())
                this.raceFirebase = raceFirebase.val()  
            })
            console.log("raceFirebase.raceResumeId----",this.raceFirebase.raceResumeId)
            let raceResumeId = this.raceFirebase.raceResumeId
            let that = this
            let apiRoot =  'https://app.liverunapp.com:443/api/'
            const AuthStr = 'Bearer '.concat(window.localStorage.getItem('default-auth-token'))
            if(fbEntry == 'racers-test'){
                apiRoot='https://liverunapi.npit.xyz/api/'
            } 

            // return RaceResumeService.get(raceResumeId)
            // .then((data) => {
            return axios.get(apiRoot+`race-resumes/`+raceResumeId,{ headers: { authorization: AuthStr } })
              .then(async (data) => {
              console.log("RaceResume Data->>",data)
              let fbRunners = []
              console.log("2endrace-fbEntry--",fbEntry)
              await db.ref(`/${fbEntry}/${raceId}/runners`)
                .once('value', (runnerFirebase) => {
                  if (runnerFirebase.val()) {
                    const snap = runnerFirebase.val()
                    Object.keys(snap).forEach((key) => {
                      snap[key].id = key
                      fbRunners.push(snap[key])
                    })
                  }
              })
              const raceResume = {
                // id: data.body.id,
                // finishDate: new Date().toISOString(),
                // startDate: data.body.startDate,
                // race: data.body.race,
                id: data.data.id,
                finishDate: new Date().toISOString(),
                startDate: data.data.startDate,
                race: data.data.race,
                totalAmountRunners: fbRunners.length                    
              }   
            
              // RaceResumeService.update(raceResume)
              //   .then(() => {
              axios.put(apiRoot+`race-resumes`,raceResume,{ headers: { authorization: AuthStr } })
              .then(() => {
                  console.log("update race -resume--->>",fbEntry)
                  db.ref(`/${fbEntry}/${raceId}`).update({
                    'status': 'finished'
                  })

                  return axios.put(apiRoot+`races/`+raceId+`/finish-race`,{},{ headers: { Authorization: AuthStr } })
                  .then(() => {
                       _LTracker.push('Race::: '+ raceId +' Finished Time Updated  By Trainer: ' + this.$auth.user().id)
                        console.log("RaceResume updated!")
                        this.finishRace(raceId,fbEntry)     
                  }).catch((e)=>{
                      console.log("errr---",e)
                      this.retryFinishRace(raceId,fbEntry)
                  })   



                  // return this.$store
                  //   .dispatch('Race/finish',raceId)
                  //   .then(() => {
                  //      _LTracker.push('Race::: '+ raceId +' Finished Time Updated  By Trainer: ' + this.$auth.user().id)
                  //       console.log("RaceResume updated!")
                  //       this.finishRace(raceId,fbEntry)     
                  //   }).catch((e)=>{
                  //     console.log("errr---",e)
                  //     this.retryFinishRace(raceId,fbEntry)
                  //    })                    
                })
              
            })
            .catch(function(error) {
              // This will be triggered when user clicks on cancel
              console.log(error)
              console.log('We are not able to find raceresume Id Still we are trying to finish the current race!')
              that.finishRace(raceId,fbEntry)  
            })
      },

      retryFinishRace(raceId,fbEntry){
          let apiRoot =  'https://app.liverunapp.com:443/api/'
          const AuthStr = 'Bearer '.concat(window.localStorage.getItem('default-auth-token'))
          if(fbEntry == 'racers-test'){
              apiRoot='https://liverunapi.npit.xyz/api/'
          } 
          console.log("ReTry finish race")
          return axios.put(apiRoot+`races/`+raceId+`/finish-race`,{},{ headers: { Authorization: AuthStr } })
          .then(() => {
                _LTracker.push('Race::: '+ raceId +' Finished Time Updated  By Trainer: ' + this.$auth.user().id)
                console.log("RaceResume updated!")
              this.finishRace(raceId,fbEntry)     
          }).catch((e)=>{
              console.log("again errr---",e)
              this.finishRace(raceId,fbEntry) 
          })   

        // this.$store.dispatch('Race/finish',raceId).then(() => {
        //     _LTracker.push('Race::: '+ raceId +' Finished Time Updated  By Trainer: ' + this.$auth.user().id)
        //      console.log("RaceResume updated!")
        //      this.finishRace(raceId,fbEntry)    
        //   }).catch((e)=>{
        //     console.log("again errr---",e)
        //     this.finishRace(raceId,fbEntry)                           
        //   })
      },

    finishRace(raceId,fbEntry){
      console.log("finish---",fbEntry)
        db.ref(`/${fbEntry}/${raceId}`).update({
            statusLive: "finished"
        })
        _LTracker.push("Race::: " +raceId +" Live Finished By Trainer: " +this.$auth.user().id)

        if(fbEntry == 'racers-test'){
           this.getRunnerData(raceId, 1, false,1)    
        }
        else {
           this.getRunnerData(raceId, 1, false,0)  
        }          
    },
    getRunnerData(raceId, loadRunners, loadUpdatedData,isStaging) {
      var that = this
      const AuthStr = "Bearer ".concat(
        window.localStorage.getItem("default-auth-token")
      )
      //this.$expressApi+`updateRace/`
      //http://localhost:3005/updateRace/
      //axios.get(this.$expressApi+`updateRace/`+raceId+`?loadRunners=` + loadRunners +
      console.log("apiUrl---",this.apiUrl,"st---",isStaging)
       axios.get(this.apiUrl+`updateRace/`+raceId+`?loadRunners=` + loadRunners +
      `&staging=`+isStaging+`&loadUpdatedData=`+loadUpdatedData,
       { headers: { Authorization: AuthStr } }).then(response => {

       })
        .catch(e => {
          console.log("error in runner data---",e)
          _LTracker.push("Catching Error from API Server!")
          //that.initialize()
          that.reInitialize()
        })
        .then(() => {
            console.log("finished live")
            //that.initialize()
            that.reInitialize()
            // setTimeout(function() {
            //   console.log("finished live inn")
            //   that.initialize()
            // }, 4000)         
        })
    },
    reInitialize(){
      if(this.apiName == 'local'){
        this.initializeLocal()
      }else if(this.apiName == 'st5'){
        this.initializeSt5()
      }else if(this.apiName == 'st4'){
        this.initializeSt4()
      }else{
        this.initializeSt6()
      }
    },
  },
  

  created() {
    // Set apiUrl from environment config
    this.apiUrl = this.$expressApi || ''
    this.initializeSt6()
    this.initializeSt5()
    this.initializeSt4()
    //this.initializeLocal()

    //this.initialize()
  },
  watch: {},
  components: {
    Container,
    TextField
  }
}



 Vue.component('table-operation',{
        template:`<span>       
        <button id="finish-live-btn" class="btn btn--primary" 
        @click.stop.prevent="finishLive(rowData.raceId)">Finish</button>      
      
        <router-link id="view-race-btn" class="btn btn--primary" 
        :to="{ path: path }">View</router-link>


      </span>
      `,
        data: () => ({
          path: ''
        }),
        props:{
            rowData:{
                type:Object
            },
            field:{
                type:String
            },
            index:{
                type:Number
            }
        },
        methods:{
          finishLive(raceId) {    
            console.log('this.field---',this.field)         
             let params = {index:this.index,rowData:this.rowData}
            //let params = {type:'edit',index:this.index,rowData:this.rowData}
              this.$emit('on-custom-comp',params)
          },
          // viewRace(id){
          //    this.$router.push(`/admin/live-run/race/${id}`)
          // },
          mountPath () {
            this.path = `/admin/live-run/race/${this.rowData.raceId}`
          } 
        },
        created () {
          this.mountPath()
        },

    })
</script>

<style>
#preview {
  width: 50%;
}
.active-run-table .v-table-title-cell{
  color:white;
}
/* .refresh-data {
  background: #3b318a;
    border: 1px solid #3b318a;
    color: #fff;
    padding: 7px 20px 7px 20px;
    border-radius: 22px;
} */

button#refresh-btn {
    line-height: 1;
    height: 30px;
    border-radius: 14px;
}

.refresh-data {
    margin: 25px 0 15px 0;
}

button#finish-live-btn {
    height: 30px;
    line-height: 1;
}

a#view-race-btn {
    height: 30px;
    line-height: 2;
}

</style>



// WEBPACK FOOTER //
// ActiveRuns.vue?6d916c0d